exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".iframe-style {\n  width: 1600px;\n  padding-left: 18px;\n  padding-top: 6px; }\n\n.span-margin {\n  margin-left: 24px; }\n\n.header-margin {\n  margin-top: 1rem; }\n\n.main-div {\n  display: block;\n  height: 100%;\n  width: 100%; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/disaster-recovery/disaster-recovery-embed.scss
// module id = BiZH
// module chunks = 0